import React from "react";

const Footer = () => {
  return (
    <div>
      <hr />

      <div style={{ marginTop: "20px" }}>
        <h2>Contact Information</h2>
        <p>
          If you have any questions or need further assistance, please contact
          our customer support team at:
        </p>
        <address>
          Email: <a href="mailto:etech@gmail.com">etech@gmail.com</a>
          <br />
          Phone: <a href="tel:+25191774">+25191774</a>
        </address>
      </div>
    </div>
  );
};

export default Footer;
